import { Heading } from '@radix-ui/themes'
import * as React from 'react'
import { testId } from '#app/utils/client/test-id.ts'

/* -------------------------------------------------------------------------------------------------
 * ProductName
 * -----------------------------------------------------------------------------------------------*/

enum TEST_IDS {
	productName = 'product-name',
}

type ProductNameProps = (typeof Heading)['defaultProps'] & {
	name: string
}

const ProductName: React.FC<ProductNameProps> = (props) => {
	const { name, ...rest } = props

	const title = React.useMemo(() => {
		let title = ''
		name.split(' – ').forEach((value, index, array) => {
			if (!index && array.length > 1) {
				title += `${value}\n – `
			} else if (array.length - 1 === index) {
				title += `${value}`
			} else {
				title += `${value} –\n`
			}
		})

		return title
	}, [name])

	return (
		// @ts-ignore
		<Heading
			as="h3"
			color="gray"
			size="3"
			className="whitespace-pre-line"
			{...rest}
			{...testId(TEST_IDS.productName)}
		>
			{title}
		</Heading>
	)
}
ProductName.displayName = 'ProductName'

/* -----------------------------------------------------------------------------------------------*/

export { ProductName, TEST_IDS as TEST_IDS_PRODUCT_NAME }
